import {
  GET_PERSONALISE_QUESTIONS,
  GET_USER_IS_FROM_BETA_PRODUCT,
  GET_USER_UUID,
  RESET_PERSONALISE_ANALYSIS,
  RESET_PERSONALISE_MCQ_ANSWER,
  RESET_PERSONALISE_QUESTIONS,
  SET_CUSTOM_SKILL_SELECTED,
  SET_ONBOARDING_DATA,
  SET_PERSONALISE_ANALYSIS,
  SET_PERSONALISE_COURSE_NAME,
  SET_PERSONALISE_COURSE_RANDOM_NO,
  SET_PERSONALISE_COURSE_SKILL_LEVEL,
  SET_PERSONALISE_COURSE_USER_INTERESTS,
  SET_PERSONALISE_MCQ_ANSWER,
  SET_PERSONALISE_USER_RANK,
  SET_PERSONALIZE_AUTH_DATA,
  SET_USER_MODAL,
  SET_USER_PERSONALISE_COURSE,
  SET_USER_UNLOCKED_PERSONALISE_COURSES,
} from "../actions/types";

const initialState = {
  UUID: "",
  skill_name: "",
  skill_slug: "",
  skillDetails: {},
  questions: {},
  analysis: {},
  onboardingData: {},
  answers: [],
  randomNo: 0,
  score: 0,
  rank: 0,
  customSkillSelected: false,
  userPersonalisedCourses: [],
  userUnlockedPersonalisedCourses: [],
  userInterests: {
    step: 1,
    courseName: "",
    skillDetails: {},
    goal: "",
    role: "",
    timing: "",
  },
  betaUsers: {},
  userAuthenticate : {}
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USER_UUID:
      const { uuid } = action.payload;
      return {
        ...state,
        UUID: uuid,
      };
    case SET_PERSONALIZE_AUTH_DATA:
      return {
        ...state,
        userAuthenticate : action.payload
    }
    case SET_ONBOARDING_DATA:
      return {
        ...state,
        onboardingData: action.payload,
      };
    case GET_PERSONALISE_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };
    case RESET_PERSONALISE_QUESTIONS:
      return {
        ...state,
        questions: [],
      };
    case SET_PERSONALISE_COURSE_NAME:
      const { skill_name, skill_slug } = action.payload;
      return {
        ...state,
        skill_name: skill_name,
        skill_slug: skill_slug,
      };
    case SET_PERSONALISE_COURSE_SKILL_LEVEL:
      return {
        ...state,
        skillDetails: action.payload,
      };
    case SET_PERSONALISE_ANALYSIS:
      const { analysis, score } = action.payload;
      return {
        ...state,
        analysis: analysis,
        score: score,
      };
    case RESET_PERSONALISE_ANALYSIS:
      return {
        ...state,
        analysis: {},
      };
    case SET_PERSONALISE_COURSE_RANDOM_NO:
      return {
        ...state,
        randomNo: action.payload,
      };
    case SET_PERSONALISE_COURSE_USER_INTERESTS:
      return {
        ...state,
        userInterests: action.payload,
      };
    case SET_PERSONALISE_MCQ_ANSWER:
      const { answer, index } = action.payload;
      if (state.answers[index]) {
        const newArray1 = state.answers.slice(0, index);
        const newArray2 = state.answers.slice(index);
        newArray2[0] = answer;
        return {
          ...state,
          answers: [...newArray1, ...newArray2],
        };
      } else {
        return {
          ...state,
          answers: [...state.answers, answer],
        };
      }
    case RESET_PERSONALISE_MCQ_ANSWER:
      return {
        ...state,
        answers: [],
      };
    case SET_PERSONALISE_USER_RANK:
      return {
        ...state,
        rank: action.payload,
      };
    case SET_CUSTOM_SKILL_SELECTED:
      return {
        ...state,
        customSkillSelected: action.payload,
      };
    case GET_USER_IS_FROM_BETA_PRODUCT:
      return {
        ...state,
        betaUsers: action.payload,
      };
    case SET_USER_PERSONALISE_COURSE:
      return {
        ...state,
        userPersonalisedCourses: action.payload,
      };

    case SET_USER_UNLOCKED_PERSONALISE_COURSES:
      return {
        ...state,
        userUnlockedPersonalisedCourses: action.payload,
      };

    default:
      return state;
  }
}
